module.exports = __webpack_public_path__ + "static/media/20170620-_DSC070306.e5d9c501.jpg";